<div class="vertical-button-group"
     [attr.data-testid]="testId()">
  @for (button of buttons(); track $index) {
    <p-button [label]="button.label"
              type="button"
              [severity]="button.severity || null"
              [outlined]="!!button.outlined"
              [text]="!!button.text"
              [loading]="!!button.loading"
              [disabled]="!!button.disabled"
              [class]="button.class || null"
              [styleClass]="resolveStyleClass(button)"
              (click)="handleClick(button)"
              [attr.data-testid]="button.testId || null" />
  }
</div>